module.exports = __webpack_public_path__ + "img/vista_mobile.91c74ba3.jpeg";